import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { BotsCreators } from '../../../../store/actions/bots';
import { UserActions } from '../../../../store/actions/users';
import Toggle from '../../../Elements/Toggle';
import Footer from '../../../Footer2/index';
import HelpBallon from '../../../Intelligence/component/HelpBalloon/HelpBalloon';

import './styles.scss';

function ChannelConfigSecurity(props) {
  const { bot, match, retrieveBotRequest, updateBotRequest, i18n, user } =
    props;

  const botid = match?.params?.botid;

  const [channelsSettings, setchannelsSettings] = useState({
    storeContactNumber: bot?.channelsSettings?.storeContactNumber || false,
    storeMessageHistory: bot?.channelsSettings?.storeMessageHistory || false,
    messageDefault: bot?.channelsSettings?.messageDefault || '',
    exposeContactNumber: bot?.channelsSettings?.exposeContactNumber || false,
  });

  useEffect(() => {
    if (botid) {
      retrieveBotRequest(botid);
    }
  }, [botid]);

  useEffect(() => {
    if (bot && bot.channelsSettings) {
      setchannelsSettings(bot.channelsSettings);
    }
  }, [bot]);

  const updateBot = () => {
    if (botid) {
      const data = channelsSettings;
      updateBotRequest(botid, { channelsSettings: data }, true);
    }
  };

  const handleHideContactChange = () => {
    setchannelsSettings({
      ...channelsSettings,
      storeContactNumber: !channelsSettings.storeContactNumber,
    });
  };

  const handleHideMessagesChange = () => {
    setchannelsSettings({
      ...channelsSettings,
      storeMessageHistory: !channelsSettings.storeMessageHistory,
    });
  };

  const handleMessageDefault = (value) => {
    setchannelsSettings({
      ...channelsSettings,
      messageDefault: value,
    });
  };

  const handleExposeContactDefault = () => {
    const { exposeContactNumber } = channelsSettings;
    setchannelsSettings({
      ...channelsSettings,
      exposeContactNumber: !exposeContactNumber,
    });
  };

  return (
    <div className="channelConfiguracaoSeguranca-container">
      <div className="col-md-6 mt-5">
        <span className="channel-title">
          {i18n.t('Configurações de privacidade e segurança')}
        </span>
        <div className="channel-advancedConfig mt-2">
          <div className="d-flex align-items-center">
            <Toggle
              identifier="storeContactNumber"
              disabled={
                !!(user && user.selectedCompany?.claim?.name === 'Viewer')
              }
              name="storeContactNumber"
              checked={channelsSettings.storeContactNumber}
              onChange={() => handleHideContactChange()}
            />
            <div className="toggle-label">
              <span>{i18n.t('Não salvar contato do usuário')}</span>
            </div>

            <HelpBallon
              id="help-ballon-check-agente"
              message={i18n.t(
                'Se ativo a boteria não irá armazenar o contato telefonico do usuário no canal do whatsApp'
              )}
            />
          </div>

          <div className="d-flex align-items-center">
            <Toggle
              identifier="storeMessageHistory"
              disabled={
                !!(user && user.selectedCompany?.claim?.name === 'Viewer')
              }
              name="storeMessageHistory"
              checked={channelsSettings.storeMessageHistory}
              onChange={() => handleHideMessagesChange()}
            />
            <div className="toggle-label">
              <span>{i18n.t('Não armazenar mensagens de usuários')}</span>
            </div>

            <HelpBallon
              id="help-ballon-check-agente"
              message={i18n.t(
                'Se ativo a boteria não irá armazenar nenhuma mensagem enviada ao bot pelo usuário'
              )}
            />
          </div>

          <div className="d-flex align-items-center">
            <input
              disabled={!channelsSettings.storeMessageHistory}
              type="text"
              className="form-control box-auth__form-control"
              name="messageDefault"
              placeholder={i18n.t('Mensagem padrão a ser apresentada')}
              onChange={(e) => handleMessageDefault(e.target.value)}
              value={channelsSettings.messageDefault}
            />

            <HelpBallon
              id="help-ballon-check-agente"
              message={i18n.t(
                'Mensagem padrão a ser apresentada no histórico de mensagem caso a opção acima estiver ativa'
              )}
            />
          </div>

          <div className="d-flex align-items-center">
            <Toggle
              identifier="exposeContactNumber"
              disabled={
                !!(user && user.selectedCompany?.claim?.name === 'Viewer')
              }
              name="exposeContactNumber"
              checked={channelsSettings.exposeContactNumber}
              onChange={() => handleExposeContactDefault()}
            />
            <div className="toggle-label">
              <span>{i18n.t('Visualizar número de contato')}</span>
            </div>

            <HelpBallon
              id="help-ballon-check-agente"
              message={i18n.t(
                'No histórico de mensagens, serão exibidos números de telefone dos clientes no lugar dos ids das sessões para todos os usuários'
              )}
            />
          </div>

          <button
            disabled={
              !!(user && user.selectedCompany?.claim?.name === 'Viewer')
            }
            className="btn btn-primary mt-3"
            onClick={updateBot}
            type="button"
          >
            {i18n.t('salvar')}
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

const mapStateToProps = (state) => ({
  bot: state.bots.bot,
  user: state.users.signedUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...BotsCreators, ...UserActions }, dispatch);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ChannelConfigSecurity))
);
